import React from 'react';
import { Typography } from '@mui/material';

const AdminDashboardPage: React.FC = () => {
  return <Typography variant="h4">Admin Dashboard</Typography>;
};

export default AdminDashboardPage;
